module.exports = __webpack_public_path__ + "media/application/images/ui/badge-trusted-small-0d6de94351205252934b04013e53d03f.png";